import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import FailedPayments from './Components/FailedPayments';
import theme from 'theme';
import PayMethods from './Components/PayMethods';
import MicrodepositsEntry from './Components/MicrodepositsEntry';
import InvoiceDownload from './Components/business/InvoiceDownload';
import PaymentLocationQRCodes from './Components/PaymentLocationQRCodes';
import PaymentFaq from './Components/PaymentFaq';
import LocationDiscounts from './Components/business/LocationDiscounts';
import { PermissionType, useUserContext } from 'UserContext';
import DuePayments from './Components/DuePayments';
import ManualPayerMethods from './Components/ManualPayerMethods';

const Payments = () => {
    const mdUp = useMediaQuery(theme.breakpoints.up('md'));
    const { hasPermission, user } = useUserContext();

    const canManagePayments = hasPermission(PermissionType.ManagePayments);
    const isManualPayer = user?.is_manual_payer;

    return (
        <Grid
            container
            justifyContent="center"
            alignContent="center"
            direction="column"
            style={{ padding: 10, paddingBottom: 100 }}
        >
            <Grid container justifyContent="center">
                <Grid container item direction="row" lg={10} md={12} sm={9} xs={12}>
                    <Grid item direction="column" lg={6} md={6} sm={9} xs={12} style={{ paddingRight: mdUp ? 20 : 0 }}>
                        <Grid item>
                            {canManagePayments ? <MicrodepositsEntry /> : null}
                            {canManagePayments && !isManualPayer ? (
                                <>
                                    <FailedPayments />
                                    <PayMethods />
                                </>
                            ) : null}
                            {canManagePayments && isManualPayer ? (
                                <>
                                    <DuePayments />
                                    <ManualPayerMethods />
                                </>
                            ) : null}
                            <PaymentFaq />
                        </Grid>
                    </Grid>
                    <Grid item direction="column" lg={6} md={6} sm={9} xs={12} alignContent="flex-start">
                        <Grid item xs={12}>
                            {canManagePayments ? <InvoiceDownload /> : null}
                            <PaymentLocationQRCodes />
                            <LocationDiscounts />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Payments;
